<template>
    <div class="product-container">
        <div class="actions">
            <v-icon v-on:click.stop="toggleModal(link.link)" v-if="link.link">fas fa-qrcode</v-icon>
            <v-icon v-on:click.stop="copyLink(link.link)" v-if="link.link">fas fa-copy</v-icon>
        </div>
        <div>
            <div class="header">
                <div style="width: 100%">
                    <v-icon class="link-icon">fas fa-{{link.icon}}</v-icon>
                    <h3 class="link-title">{{ link.title }}</h3>
                    <p class="link-subtitle" v-if="link.link">{{ link.link }}</p>
                </div>
            </div>
            <p class="link-text" v-html="link.description.replace(/(?:\r\n|\r|\n)/g, '<br />')">
            </p>
        </div>
        <div class="link-links" v-if="link.bannersLink || link.emailFormatLink || link.rulesLink">
            <a target="_blank" :href="link.bannersLink" v-if="link.bannersLink">Banners</a>
            <a target="_blank" :href="link.emailFormatLink" v-if="link.emailFormatLink">Formato para Email</a>
            <a target="_blank" :href="link.rulesLink" v-if="link.rulesLink">Regras e Dicas</a>
        </div>
        <div>
            <div v-if="link.requestStatusId && !link.link">
                <p class="link-alert" v-if="link.request">Status da solicitação: {{ getRequestStatus(link) }}</p>
            </div>

            <div class="link-box-footer" v-if="link.request && !link.link && (link.requestStatusId == 1 || link.requestStatusId == null)">
                <button class="button-copy-link request" v-on:click.stop="requestLink(link.id, link.applicationId)">
                    <p>Solicitar Link</p>
                </button>
            </div>
        </div>
        <div class="modal-container-qrcode hidden">
            <div class="modal-content-qrcode">
                <div class="modal-content-header">
                    <h4>QRCode</h4>
                    <v-icon v-on:click.stop="toggleModal()">fas fa-times</v-icon>
                </div>
                <div class="qr-code affiliate-qr-code"></div>
                <button class="download-qrcode" v-on:click="download()">Baixar</button>
            </div>
        </div>
    </div>
</template>
<script>
    import QrCreator from 'qr-creator';

    export default {
        data: () => ({
            requestStatus: [],
        }),

        props: {
            link: {
                type: Object,
                required: true,
            }
        },

        methods: {
            requestLink(id, applicationId) {
                this.$api.dataService.execute('request/createRequest', { applicationId: applicationId })
                    .then(res => {
                        this.$notifyUser({
                            message: 'Link solicitado com sucesso!'
                        });

                        this.link.requestStatusId = res.requestStatusId;
                    }).catch(err => {
                        this.$notifyUser({
                            type: 'error',
                            message: err.msg
                        });
                    });
            },

            copyLink(link) {
                window.Clipboard.copy(link);
                this.$notifyUser({
                    message: 'Link copiado'
                });
            },

            getRequestStatus(link) {
                let status = this.requestStatus.find(status => status.id === link.requestStatusId).name;
                return status;
            },
            
            download() {
                var link = document.createElement('a');
                link.download = 'qrcode.png';
                link.href = document.querySelector('.affiliate-qr-code > canvas').toDataURL();
                link.click();

                this.$notifyUser({
                    message: 'QRCode baixado!'
                });
            },

            toggleModal(link) {
                if (document.querySelector(".modal-container-qrcode").classList.contains('show')) {
                    document.querySelector(".modal-container-qrcode").classList.remove('show');
                    document.querySelector(".modal-container-qrcode").classList.add('hidden');
                } else {
                    document.querySelector('.affiliate-qr-code').innerHTML = '';
                    QrCreator.render({
                        text: link,
                        radius: 0.0,
                        ecLevel: 'L',
                        fill: '#000000',
                        background: '#FFFFFF',
                        size: 200
                    }, document.querySelector('.affiliate-qr-code'));

                    document.querySelector(".modal-container-qrcode").classList.remove('hidden');
                    document.querySelector(".modal-container-qrcode").classList.add('show');
                } 
            }
        },

        async created() {
            this.requestStatus = await this.$api.dataService.search('requestStatus');
        }
    }
</script>

<style scoped>
    p {
        margin: 0;
    }

    .product-container {
        width: 100%;
        background-color: #FFF;
        transition: .2s;
        border-radius: 5px;
        padding: 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        margin-top: 57px;
        position: relative;
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
    }

    .link-icon {
        width: 40px;
        height: 40px;
        color: #4744e9 !important;
        font-size: 18px !important;
        margin-bottom: 15px;
        background-color: #4744e925;
        border-radius: 100px;
    }

    .link-title {
        font-size: 20px;
        width: 80%;
        color: #262626;
        line-height: 1.2;
        font-weight: bold;
    }

    .link-subtitle {
        color: #5589a3;
    }

    .link-text {
        font-size: 13px;
        color: #5E5E5E;
        line-height: 1.7;
        margin-top: 10px;
        padding: 20px;
        background-color: #e4f6ff;
        color: #5589a3;
        border-radius: 5px;
        font-weight: 500;
    }

    .link-box-footer {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        gap: 10px;
    }

    .link-alert {
        color: #262626;
        margin-top: 25px;
        font-style: italic;
    }

    .link-links {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        margin-top: 10px;
        gap: 10px;
    }

    .link-links > a {
        width: 100%;
        font-size: 14px;
        background-color: var(--primary-color);
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .1);
        color: white;
        padding: 10px;
        border-radius: 5px;
        text-align: center;
        text-decoration: none;
        transition: .2s;
        font-weight: bold;
    }
    .link-links > a:hover {
        background-color: var(--primary-color-hover);
    }

    .button-copy-link, .button-qr-code, .button-banners {
        width: auto;
        background-color: var(--primary-color);
        color: white;
        padding: 10px 15px !important;
        font-weight: bold;
        font-size: 12px !important;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: .5s;
        text-decoration:none;
    }

    .button-copy-link.request {
        background-color: var(--secondary-color-hover);
    }

    .button-copy-link.request:hover {
        background-color: var(--secondary-color);
    }
    
    .button-copy-link:hover, .button-qr-code:hover {
        background-color: var(--primary-color-hover);
    }

    .qr-code {
        margin-top: 25px;
    }

    .modal-container-qrcode {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #2626262f;
        z-index: 1000000000000000;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal-container-qrcode.hidden {
        visibility: hidden;
    }

    .modal-container-qrcode.show {
        visibility: visible;
    }

    .modal-content-qrcode {
        height: auto;
        padding: 30px;
        background-color: #FFF;
        border-radius: 10px;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .25);
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-direction: column;
    }

    .modal-content-header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .modal-content-header > h4 {
        color: var(--primary-color);
        font-weight: bold;
    }

    .download-qrcode {
        width: 100%;
        height: 40px;
        background-color: var(--primary-color);
        margin-top: 10px;
        border-radius: 3px;
    }

    .actions {
        position: absolute;
        top: 25px;
        right: 25px;
        display: flex;
        flex-direction: row;
        gap: 15px;
    }

    .actions > i {
        font-size: 22px;
        color: var(--primary-color);
        cursor: pointer;
    }

    @media only screen and (max-width: 768px) {
        .link-links {
            flex-direction: column;
        }

        .product-container {
            margin-top: 10px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/ProductCard.vue